import React from 'react';
import { twMerge } from 'tailwind-merge';

interface TableInfoHeaderProps {
  game: string | undefined;
  stakes: React.ReactNode;
  className?: string;
}

const TableInfoHeader: React.FC<TableInfoHeaderProps> = ({ game, stakes, className = '' }) => {
  return (
    <div className={twMerge('mr-4 flex w-auto flex-col items-start justify-center font-manrope font-bold', className)}>
      <span className="mr-2 text-sm text-ph-white">{game} </span>
      <span className="flex items-center text-sm text-ph-white-50">{stakes}</span>
    </div>
  );
};

export default TableInfoHeader;
